import * as React from 'react';
import { useSelector } from 'react-redux';

import { useButtonSticky } from './hook';
import { StickyScrollBtn } from '../../components/StickyScrollBtn';
import { selectIsStickyScrollBtnVisible } from '../../selectors/page';
import { checkHasData, useEstimationHistoryQuery } from '../../serverState/estimationHistory';

interface IStickyScrollBtnContainerParams {
  scrollToFilters(): void;
}

export function StickyScrollBtnContainer({ scrollToFilters }: IStickyScrollBtnContainerParams) {
  const stickyRef = React.useRef<HTMLDivElement>(null);

  const isBtnSticky = useButtonSticky(stickyRef.current as HTMLDivElement);
  const isStickyBtnVisible = useSelector(selectIsStickyScrollBtnVisible);

  const { data } = useEstimationHistoryQuery();
  const hasPrevEstimations = React.useMemo(() => checkHasData(data), [data]);

  const buttonText = hasPrevEstimations ? 'Оценить другой объект' : 'Перейти к оценке';

  if (!isStickyBtnVisible) {
    return null;
  }

  return (
    <StickyScrollBtn
      stickyRef={stickyRef}
      isSticky={isBtnSticky}
      scrollToFilters={scrollToFilters}
      buttonText={buttonText}
    />
  );
}
